import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'redux-first-router-link';

import { CuiNavigation } from './navigation';

export const CuiSideBar = ({
  className,
  isOpen,
  homePath,
  routes,
  title,
  author,
  ...rest
}) => {
  const classes = classNames('cuiSideBar', {
    'cuiSideBar-isOpen': isOpen,
  });

  let titleElement;

  if (title) {
    titleElement = <div className="cuiSideBarTitle">{title}</div>;
  }

  let authorElement;

  if (author) {
    authorElement = cloneElement(author, {
      className: 'cuiSideBarAuthor',
    });
  }

  return (
    <div className={classes} {...rest}>
      <Link to={homePath} className="cuiSideBarId">
        <div className="cuiSideBarId__bg" />
        <div className="cuiSideBarId__art" />
      </Link>

      {titleElement}
      {authorElement}

      <CuiNavigation routes={routes} />
    </div>
  );
};

CuiSideBar.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  homePath: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string,
  author: PropTypes.element,
  routes: PropTypes.array,
};

CuiSideBar.defaultProps = {
  className: undefined,
  isOpen: false,
  homePath: '/',
  title: undefined,
  author: undefined,
  routes: [],
};



// WEBPACK FOOTER //
// ./ui/components/sideBar/SideBar.js